"use client"

import { createContext, useContext, useState } from "react"
import PremiumModal from "./PremiumModal"

const PremiumModalContext = createContext(undefined)

export function PremiumModalProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false)
  const [message, setMessage] = useState("You need a premium subscription to access this feature.")
  const [feature, setFeature] = useState(null)
  const [onCloseCallback, setOnCloseCallback] = useState(null)

  const showPremiumModal = (customMessage, onModalClose) => {
    setFeature(null)
    setMessage(customMessage || "You need a premium subscription to access this feature.")
    setOnCloseCallback(() => (typeof onModalClose === 'function' ? onModalClose : null))
    setIsOpen(true)
  }

  const featureMessages = {
    youtube: 'YouTube-to-quiz requires Premium. Upgrade to add YouTube videos and generate quizzes from their transcripts.',
    courses: 'Free accounts can create up to 5 personal courses in each 6-month period. Upgrade to create more courses.',
    retakes: 'Free users cannot retake completed quizzes. Upgrade to Premium to practice again and track your score improvement.',
    daily_credits: "You've reached your 10 daily AI credits. Upgrade to Premium for 40 credits/day or wait until 00:00 UTC.",
    monthly_credits: "You've reached your 100 monthly AI credits. Upgrade to Premium for 800 credits/month.",
  }

  const showUpgradeModal = (featureName, customMessage) => {
    setFeature(featureName || null)
    setMessage(customMessage || featureMessages[featureName] || "You need a premium subscription to access this feature.")
    setOnCloseCallback(null)
    setIsOpen(true)
  }

  const hidePremiumModal = () => {
    setIsOpen(false)
    if (onCloseCallback) {
      const cb = onCloseCallback
      setOnCloseCallback(null)
      cb()
    }
  }

  return (
    <PremiumModalContext.Provider value={{ showPremiumModal, showUpgradeModal, hidePremiumModal }}>
      {children}
      <PremiumModal isOpen={isOpen} message={message} feature={feature} onClose={hidePremiumModal} />
    </PremiumModalContext.Provider>
  )
}

export function usePremiumModal() {
  const context = useContext(PremiumModalContext)
  if (!context) {
    throw new Error("usePremiumModal must be used within PremiumModalProvider")
  }
  return context
}
